"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genarateRSA = exports.decryptRSA = exports.encryptRSA = exports.decryptAESCBC = exports.encryptAESCBC = exports.decryptAES = exports.encryptAES = void 0;
/* eslint-disable new-cap */
//Simple
const crypto_js_1 = __importDefault(require("crypto-js"));
const AriForm_1 = require("../AriForm");
const jsencrypt_1 = __importDefault(require("jsencrypt"));
const encryptAES = (text, keyEncrypt) => {
    var key = crypto_js_1.default.enc.Base64.parse(!keyEncrypt ? AriForm_1.AriForm.encryptConfigKey : AriForm_1.AriForm.encryptUrlKey);
    var options = { mode: crypto_js_1.default.mode.ECB, padding: crypto_js_1.default.pad.Pkcs7, iv: key };
    var encrypted = crypto_js_1.default.AES.encrypt(text, key, options);
    return encrypted.toString();
};
exports.encryptAES = encryptAES;
const decryptAES = (encryptedText, keyEncrypt) => {
    encryptedText = encryptedText.replaceAll('_', '/').replaceAll("-", "+");
    var key = crypto_js_1.default.enc.Base64.parse(!keyEncrypt ? AriForm_1.AriForm.encryptConfigKey : AriForm_1.AriForm.encryptUrlKey);
    var options = { mode: crypto_js_1.default.mode.ECB, padding: crypto_js_1.default.pad.Pkcs7, iv: key };
    var decrypted = crypto_js_1.default.AES.decrypt(encryptedText, key, options);
    return decrypted.toString((crypto_js_1.default.enc.Utf8));
};
exports.decryptAES = decryptAES;
//Simple E2EE
const encryptAESCBC = (text, passphrase) => {
    const salt = crypto_js_1.default.enc.Latin1.parse(AriForm_1.AriForm.salt);
    const full = crypto_js_1.default.PBKDF2(passphrase, salt, {
        keySize: 12,
        iterations: 1000,
        hasher: crypto_js_1.default.algo.SHA1
    });
    const key = crypto_js_1.default.lib.WordArray.create(full.words.slice(0, 8), 32);
    const iv = crypto_js_1.default.lib.WordArray.create(full.words.slice(8, 12), 16);
    const encrypted = crypto_js_1.default.AES.encrypt(text, key, {
        iv, mode: crypto_js_1.default.mode.CBC, padding: crypto_js_1.default.pad.Pkcs7
    });
    return crypto_js_1.default.enc.Base64.stringify(encrypted.ciphertext);
};
exports.encryptAESCBC = encryptAESCBC;
const decryptAESCBC = (encryptedBase64, passphrase) => {
    const salt = crypto_js_1.default.enc.Latin1.parse(AriForm_1.AriForm.salt);
    const full = crypto_js_1.default.PBKDF2(passphrase, salt, {
        keySize: 12,
        iterations: 1000,
        hasher: crypto_js_1.default.algo.SHA1
    });
    const key = crypto_js_1.default.lib.WordArray.create(full.words.slice(0, 8), 32);
    const iv = crypto_js_1.default.lib.WordArray.create(full.words.slice(8, 12), 16);
    const decrypted = crypto_js_1.default.AES.decrypt({
        ciphertext: crypto_js_1.default.enc.Base64.parse(encryptedBase64)
    }, key, {
        iv: iv,
        mode: crypto_js_1.default.mode.CBC,
        padding: crypto_js_1.default.pad.Pkcs7
    });
    return decrypted.toString(crypto_js_1.default.enc.Utf8);
};
exports.decryptAESCBC = decryptAESCBC;
const encryptRSA = (text) => {
    const encrypt = new jsencrypt_1.default();
    encrypt.setPublicKey(AriForm_1.AriForm.serverPublicKey);
    const result = encrypt.encrypt(text);
    return result;
};
exports.encryptRSA = encryptRSA;
const decryptRSA = (encryptedText, key) => {
    const decrypt = new jsencrypt_1.default();
    decrypt.setPrivateKey(key);
    const text = decrypt.decrypt(encryptedText);
    return text;
};
exports.decryptRSA = decryptRSA;
const genarateRSA = () => {
    const crypt = new jsencrypt_1.default();
    return [crypt.getPrivateKey(), crypt.getPublicKey()];
};
exports.genarateRSA = genarateRSA;
//end Simple
exports.default = exports.encryptAES;
//End Simple
